module.exports = __webpack_public_path__ + "static/media/AdBlockNavIconActive.44fdc6f4.svg";